import styled from "styled-components";

const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: ${(props) => props?.theme?.themeConfig?.secondaryColor};
  padding: 25px 50px;
  border-radius:5px;
  font-family: 'Poppins', sans-serif;
  width:500px;
  border-radius: 10px;

  .voa_close_59o7kg {
    color: ${(props) => props?.theme?.themeConfig?.chatMessages?.freeform?.title?.styles?.color ?? 'black'} !important;
    top:15px !important;
    right:15px !important;
    font-size: 40px;
    position: absolute;
    font-weight: bold;
    cursor: pointer;
  }
  .error {
    color: red;
  }

  .callback-widget-header{
    color: ${(props) => props?.theme?.themeConfig?.chatMessages?.freeform?.title?.styles?.color ?? 'black'};
  }

  .field_section {
    margin-top:20px;
    color: ${(props) => props?.theme?.themeConfig?.chatMessages?.freeform?.title?.styles?.color ?? 'black'};
  }

  input[type=text], input[type=email], input[type=tel], textarea {
    width: 100%;
    padding: 10px 8px;
    margin: 4px 0;
    display: inline-block;
    border: 1px solid #ccc;
    box-sizing: border-box;
    border-radius: 4px;
    font-family: 'Poppins', sans-serif;
  }
  textarea {
    height:80px;
    resize: vertical;
    border-radius: 4px;
  }
  label {
    font-family: inherit;
  }
  .required {
    color: red;
    padding-left:5px;
  }
  button {
    width: auto;
    padding: 10px 20px;
    background-color: ${(props) => props?.theme?.themeConfig?.primaryColor};
    color: #FFFFFF;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    margin:20px auto 0px;
    display:block;
    cursor: pointer;

    &:disabled {
      opacity:0.4;
    }
  }
`;

export default Container;
